<style scoped>
.draggable-element {
  cursor: pointer;
}
</style>
<template>
  <v-flex xs12 v-if="chart">
    <v-tabs v-model="tab" centered color="grey darken-1" dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab key="0">Elements</v-tab>
      <v-tab key="1">Properties</v-tab>
      <v-tab key="2">Styles</v-tab>
      <v-tab-item key="0">
        <v-card flat>
          <v-card-text>
            <!-- <draggable
              class="dragArea list-group layout row wrap"
              :list="elements"
              :sort="false"
            >-->
            <v-layout row wrap>
              <v-flex
                xs12
                md4
                sm6
                pr-2
                text-xs-center
                v-for="item in elements"
                :key="item.type"
                class="draggable-item"
              >
                <drag
                  :transfer-data="{ draggable: true, data: item }"
                  :effect-allowed="['copy']"
                  drop-effect="copy"
                >
                  <v-btn
                    :ripple="false"
                    class="draggable-element"
                    xs12
                    depressed
                    large
                    style="width: 100%"
                    >{{ item.name }}</v-btn
                  >
                </drag>
              </v-flex>
            </v-layout>
            <!-- </draggable> -->
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item key="1">
        
        <v-card flat>
          
          <v-card-text v-if="activeElement">
            <v-flex xs12>
        <v-select
          :items="elements"
          v-model="activeElement.type"
          item-value="type"
          item-text="name"
          label="Element"
        ></v-select>
      </v-flex>
            <v-text-field
              autocomplete="off"
              pt-0
              pb-0
              label="Label"
              v-model="activeElement.label"
              outline
            ></v-text-field>
            <v-text-field
              autocomplete="off"
              v-if="activeElement.type == 'file'"
              pt-0
              pb-0
              label="Namespace (required)"
              v-model="activeElement.namespace"
              outline
              :persistent-hint="true"
              hint="Enter unique value for this file type"
            ></v-text-field>
            <v-text-field
              v-if="activeElement.onClickFunctionEnabled != true"
              autocomplete="off"
              pt-0
              pb-0
              label="Placeholder"
              v-model="activeElement.placeholder"
              outline
            ></v-text-field>
            <v-text-field
              v-if="activeElement.type == 'input'"
              autocomplete="off"
              pt-0
              pb-0
              label="Mask"
              v-model="activeElement.mask"
              outline
            ></v-text-field>
            <v-text-field
              v-if="activeElement.onClickFunctionEnabled != true"
              autocomplete="off"
              pt-0
              pb-0
              label="Help Block"
              v-model="activeElement.hint"
              outline
            ></v-text-field>
            <v-select
              :clearable="true"
              :items="designTypes"
              item-value="value"
              item-text="text"
              label="Select Design"
              v-model="activeElement.designType"
            ></v-select>
            <v-text-field
              autocomplete="off"
              pt-0
              pb-0
              label="Classes"
              v-model="activeElement.className"
              outline
            ></v-text-field>
            <v-text-field
              autocomplete="off"
              pt-0
              pb-0
              label="Style"
              v-model="activeElement.style"
              outline
            ></v-text-field>
            <v-text-field
              autocomplete="off"
              pt-0
              pb-0
              label="Color"
              v-model="activeElement.color"
              outline
            ></v-text-field>
            <!-- <v-select
              v-if="activeElement.hasSubChart == true"
              :clearable="true"
              :items="chart.tree.charts"
              item-value="id"
              item-text="name"
              label="Select DMS"
              v-model="activeElement.subChartValue"
            ></v-select> -->
            <!-- <v-switch
              v-if="activeElement.hasSubChart == true"
              pt-0
              pb-0
              v-model="activeElement.multiple"
              label="Multiple"
            ></v-switch> -->
            <v-text-field
              v-if="activeElement.onClickFunctionEnabled != true"
              autocomplete="off"
              pt-0
              pb-0
              label="Column Name"
              v-model="activeElement.column"
              outline
            ></v-text-field>
            <v-text-field
              autocomplete="off"
              pt-0
              pb-0
              label="Tab Index"
              v-model="activeElement.tabIndex"
              outline
            ></v-text-field>

            <v-switch
              v-if="activeElement.onClickFunctionEnabled != true"
              pt-0
              pb-0
              v-model="activeElement.required"
              label="Required"
            ></v-switch>
            <v-switch
              v-if="activeElement.type == 'select'"
              pt-0
              pb-0
              v-model="activeElement.multiple"
              label="Multiple"
            ></v-switch>
            <v-switch
              pt-0
              pb-0
              v-model="activeElement.isNumeric"
              label="Is Numeric ?"
            ></v-switch>
            <v-select
              v-model="activeElement.listType"
              v-if="activeElement.hasList"
              item-text="text"
              item-value="value"
              :items="listTypes"
              box
              label="List Type"
            ></v-select>
            <v-textarea
              v-show="activeElement.hasList && activeElement.listType == 'json'"
              pt-0
              pb-0
              label="JSON"
              v-on:blur="activeElement.loadItems()"
              v-model="activeElement.json"
              outline
            ></v-textarea>
            <v-textarea
              v-show="activeElement.hasList && activeElement.listType == 'sql'"
              pt-0
              pb-0
              v-on:blur="activeElement.loadItems()"
              label="SQL"
              v-model="activeElement.sql"
              outline
            ></v-textarea>
            <v-select
              v-model="activeElement.functionType"
              v-if="activeElement.onClickFunctionEnabled == true"
              item-text="text"
              item-value="value"
              :items="functionTypes"
              box
              label="On Click Functions"
            ></v-select>
            <v-text-field
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                (activeElement.functionType == 'dataAddTable' ||
                  activeElement.functionType == 'dataUpdateTable')
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Table Name"
              v-model="activeElement.functionValue"
              outline
            ></v-text-field>
            <v-textarea
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                activeElement.functionType == 'dataUpdateTable'
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Update Columns"
              v-model="activeElement.updateColumns"
              outline
            ></v-textarea>
            <v-textarea
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                (activeElement.functionType == 'dataAddTable' ||
                  activeElement.functionType == 'dataUpdateTable')
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Default Columns"
              v-model="activeElement.defaultColumns"
              outline
            ></v-textarea>
            <v-textarea
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                (activeElement.functionType == 'dataAddTable' ||
                  activeElement.functionType == 'dataUpdateTable')
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Success Message"
              v-model="activeElement.successMessage"
              outline
            ></v-textarea>
            <v-textarea
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                (activeElement.functionType == 'dataAddTable' ||
                  activeElement.functionType == 'dataUpdateTable')
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Error Message"
              v-model="activeElement.errorMessage"
              outline
            ></v-textarea>
            <v-text-field
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                activeElement.functionType == 'api'
              "
              autocomplete="off"
              pt-0
              pb-0
              label="API Endpoint"
              v-model="activeElement.functionValue"
              outline
            ></v-text-field>
            <v-text-field
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                activeElement.functionType == 'openDashboard'
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Dashboard Name"
              v-model="activeElement.functionValue"
              outline
            ></v-text-field>
            <v-text-field
              v-if="
                activeElement.onClickFunctionEnabled == true &&
                activeElement.functionType == 'openLink'
              "
              autocomplete="off"
              pt-0
              pb-0
              label="Link"
              v-model="activeElement.functionValue"
              outline
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item key="2">
        <v-card flat>
          <v-card-text>Text 3</v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</template>
<script>
// :group="{ name: 'people', pull: 'clone', put: false }"
// :clone="cloneDog"
// @change="log"
import { elements } from "./hydrator";
import draggable from "vuedraggable";
import { Drag } from "vue-drag-drop";
console.log("elements", elements);
export default {
  props: ["chart"],
  data: function () {
    return {
      tab: 0,
      activeElement: null,
      setTabCount: 0,
      elements: elements,
      designTypes: [
        { value: "outline", text: "Outline" },
        { value: "regular", text: "Regular" },
        { value: "solo", text: "Solo" }
      ],
      listTypes: [
        { value: "json", text: "JSON" },
        { value: "sql", text: "SQL" },
      ],
      functionTypes: [
        { value: "dataAddTable", text: "Add Data" },
        { value: "dataUpdateTable", text: "Update Data" },
        { value: "api", text: "API" },
        { value: "openDashboard", text: "Open Dashboard" },
        { value: "resetForm", text: "Reset Form" },
        { value: "openLink", text: "Open Link" },
      ],
    };
  },
  components: {
    draggable,
    drag: Drag,
  },
  methods: {
    setTab(tab) {
      if(this.setTabCount == 0) {
        this.tab = 0;
        this.setTabCount++;
        return;
      }
      this.tab = parseInt(tab);
      this.setTabCount++;
      
    }
    
  },
  computed: {},
  mounted: function () {
    const that = this;
    this.chart.setTab = function (tab) {
      that.setTab(tab);
      
      // that.tab = parseInt(tab);
      
    };
    this.chart.setActiveElement = function (element) {
      // that.setActiveElement(element);
      that.activeElement = element;
      // that.tab = 1;
      // that.chart.setTab(1);
      //  console.log("element", that.activeElement);
    };
  },
  beforeDestroy() {},
};
</script>
